<script lang="ts" setup>
import { computed, ref } from 'vue';

export type ButtonStyle =
  | 'btn-primary'
  | 'btn-triadic'
  | 'btn-triadic-half'
  | 'btn-success'
  | 'btn-warning'
  | 'btn-dark'
  | 'btn-default'
  | 'btn-info'
  | 'btn-cancel'
  | 'btn-secondary' // ここから以下2024/03/19 更新・追加
  | 'btn-disabled'
  | 'btn-error'
  | 'btn-secondary-error'
  | 'btn-secondary'
  | 'btn-disabled-error'
  | 'btn-tertiary';

declare type ClickFunc = (args?: any) => any;

// props
const props = withDefaults(
  defineProps<{
    onClick: ClickFunc;
    typography?: string;
    buttonStyle?: ButtonStyle;
    disabled?: boolean;
    toolTipValue?: string;
    eventModifier?: string;
  }>(),
  {
    typography: '',
    buttonStyle: 'btn-default',
    size: 'sm',
    disabled: false,
    toolTipValue: '',
    eventModifier: '',
  }
);

// 変数
const el = ref<HTMLButtonElement | null>(null);

// ボタンのフォーカスを公開
defineExpose({
  focus: () => el.value?.focus(),
});

// computed
const buttonClasses = computed(() => {
  const classList = ['inline-block', props.buttonStyle, props.typography];
  return classList.filter((item) => item).join(' ');
});

// script
const handleClickButton = (event: MouseEvent) => {
  props.onClick(event);
};
</script>

<template>
  <button
    v-if="eventModifier === 'stop'"
    ref="el"
    v-tooltip="toolTipValue"
    :class="buttonClasses"
    :disabled="disabled"
    class="button_content"
    @click.stop="handleClickButton"
  >
    <slot />
  </button>
  <button
    v-else-if="eventModifier === 'prevent'"
    ref="el"
    v-tooltip="toolTipValue"
    :class="buttonClasses"
    :disabled="disabled"
    class="button_content"
    @click.prevent="handleClickButton"
  >
    <slot />
  </button>
  <button
    v-else
    ref="el"
    v-tooltip="toolTipValue"
    :class="buttonClasses"
    :disabled="disabled"
    class="button_content"
    @click.stop="handleClickButton"
  >
    <slot />
  </button>
</template>

<style lang="scss" scoped>
.button_content {
  cursor: v-bind('props.disabled ? `not-allowed` : `pointer`');
  font-weight: bold;
  user-select: none;
  border-radius: 4px;
  touch-action: manipulation;
  box-shadow: v-bind(
    'props.disabled ? `none` : `0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%)`'
  );
  opacity: v-bind('props.disabled ? 0.6 : 1');
}
</style>
